/**
 * ArrayTransformer class.
 */
class ArrayTransformer {
    /**
     * Inverse Lat & Lng
     *
     * @param datas
     */
    public LatLngTransformer(datas: any) {
        datas.forEach((item: any, index: number) => {
            item.forEach((subItem: any, subIndex: number) => {
                if (Array.isArray(subItem) && 2 < subItem.length) {
                    subItem.forEach((val: any, valIndex: number) => {
                        datas[index][subIndex][valIndex] = [val[1], val[0]];
                    });
                } else {
                    datas[index][subIndex] = [subItem[1], subItem[0]];
                }
            });
        });

        return datas;
    };
}

export default new ArrayTransformer();
